import { ChangeEvent, useEffect, useRef, useState } from "react"
import { ISearchBox } from "@fluentui/react";
import { IHistoriaEstadoEquipoDTO, IHistoriaEstadoEquipoRequest, InitialEstadoEquipoRequest } from "../../../../Interfaces/auxiliar/IReporte"
import { IPaginacionComponent } from "../../../../Interfaces/filter";
import { ReporteService } from "../../../../services/auxiliar/ReporteSerive";
import { IPaginationV2 } from "../../../../Interfaces/base/ITable";
import { formatDate_DDMYY_guion, formatGuionFecha } from "../../../../utils/helpers/dateHelpers";

export type keyType = "operadorKey" | "estadoKey"
export type textType = "operadorText" | "estadoText"

export interface IFilter2 {
  operadorKey: string,
  operadorText: string
  estadoKey: string,
  estadoText: string
  fechaInicio:string
  fechaFin:string
}

const initialFilter2: IFilter2 = {
  operadorKey: "",
  operadorText: "",
  estadoKey: "",
  estadoText: "",
  fechaInicio:"",
  fechaFin:""
}

export interface IT {
  key: keyType, keyValue: string, text: textType, textValue: string
}

const UseReporteHistoricoEstado = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const onChangeSearch = useRef<ISearchBox>(null);
  const [items, setItems] = useState<IHistoriaEstadoEquipoDTO[]>([])
  const [filter2, setFilter2] = useState<IFilter2>({ ...initialFilter2 });
  const [filter, setFilter] = useState<IHistoriaEstadoEquipoRequest>(InitialEstadoEquipoRequest);
  const [control, setControl] = useState(true);

  const initial: IHistoriaEstadoEquipoRequest = {
    skip: 0,
    take: 50,
    search: ""
  };


  const resetFilter2 = () => {
    setFilter2({ ...initialFilter2 });
    setFilter({
        skip: 0,
        take: 50,
        search: "",
    })
    setControl(true);
};
  const _onkeyUpSearchTable = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
    setControl(true)
  };

  const onChangeTake = (value: number) => {
    setFilter({ ...filter, take: value })
    setControl(true)
  };
  const onSkip = (value: number) => {
    const realSkip = (value * filter.take) - filter.take
    setFilter({ ...filter, skip: realSkip })
    setControl(true)
  };

  const handleResetUpdate = () => {
    setFilter(initial);
    setControl(true)
  };
  const [pagination, setPagination] = useState<IPaginationV2>({
    currentPage: 0,
    total: 0,
    pageSize: 0,
    skip: 0,
    take: 50,
    onPageChange: function (value: number): void {
    },
    onSizeChange: function (value: number): void {
    }
  })

  const getHistoricoEstadoEquipo = () => {
    setLoading(true);
    ReporteService.ReporteHistoricoEstadoEquipo(filter)
      .then((res) => {
        const pag: IPaginationV2 = {
          currentPage: res.data.page,
          total: res.data.total,
          pageSize: res.data.pages,
          onPageChange: onSkip,
          skip: filter.skip,
          take: filter.take,
          onSizeChange: onChangeTake
        };
        setPagination(pag);
        setLoading(false);
        setItems(res.data.items);
      })
      .catch((e: any) => {
        setLoading(false);
      });
  };

  const onChangeComboFilter = ({ key, keyValue, text, textValue }: IT) => {
    setFilter2(prevState => ({
      ...prevState,
      [key]: keyValue,
      [text]: textValue,
    }));
  };
  const onChangeFecha=(key:string,value:string)=>{
    setFilter2({...filter2,[key]:value})
  }

  const buscar = () => {
    console.log(filter2)
    setFilter({
      skip: 0,
      take: 50,
      search: "",
      operadorId: (filter2.operadorKey != "") ? filter2.operadorKey : undefined,
      estadoId: (filter2.estadoKey != "") ? filter2.estadoKey : undefined,
      fechaDesde: (filter2.fechaInicio != "") ? formatGuionFecha(filter2.fechaInicio,false) : undefined,
      fechaHasta: (filter2.fechaFin != "") ? formatGuionFecha(filter2.fechaFin,true) : undefined,
    })
    setControl(true);
  }

  useEffect(() => {
    if (control) {
        getHistoricoEstadoEquipo();
        setControl(false);
    }
}, [control]);

  return {
    items,
    filter,
    setFilter,
    loading,
    pagination,
    handleResetUpdate,
    onChangeSearch,
    onChangeTake,
    _onkeyUpSearchTable,
    onChangeComboFilter,
    buscar,
    filter2,
    setFilter2,
    resetFilter2,
    getHistoricoEstadoEquipo,
    onChangeFecha
  }
}

export { UseReporteHistoricoEstado }